import React from "react";
import { Loader } from "semantic-ui-react";
import { loginStatusOptions } from "../AuthProvider/AuthProvider";
import styles from "./LoginScreen.module.scss";
import koneLogo from "../../images/kone-logo-white.svg";
import loginIcon from "../../images/enter.svg";

export interface LoginProps {
  loginStatus: loginStatusOptions;
  onLoginClick: () => void;
}

const LoginScreen = (props: LoginProps): JSX.Element => {
  const { loginStatus, onLoginClick } = props;
  const loginPromptClasses =
    loginStatus === "Prompt" ? [styles.loginPrompt, styles.fadeIn] : [styles.loginPrompt];

  return (
    <div className={styles.loginWrapper}>
      <div className={loginPromptClasses.join(" ")}>
        <div className={styles.loginTitle}>
          <img src={koneLogo} width={50} alt="KoneLog" />
          <span>KCE Database Tools 2</span>
        </div>

        {loginStatus === "Prompt" ? (
          <div id="loginButton" className={styles.loginButton} onClick={() => onLoginClick()}>
            <span>Login with AAD </span>
            <img src={loginIcon} alt="Login Button" />
          </div>
        ) : (
          <Loader
            active={true}
            content={loginStatus}
            inline={true}
            inverted={true}
            className={styles.loginLoader}
          />
        )}
      </div>
    </div>
  );
};

export default LoginScreen;
